import React, { useState } from "react";
import { getWord } from "../../utils/functions";
import { useSelector } from "react-redux";
import Login from "./Login";
import { Link } from "react-router-dom";

const Footer = () => {
  const year = new Date().getFullYear();
  const settings = useSelector((state) => state.settings);
  const lang = useSelector((state) => state.lang);
  const user = useSelector((state) => state.user);
  const [isLoginOpen, setIsLoginOpen] = useState(false);

  const openLogin = () => setIsLoginOpen(true);
  const closeLogin = () => setIsLoginOpen(false);

  return (
    <>
      <footer id="footer" className="footer background-gray md-pb-70">
        <div className="footer-wrap">
          <div className="footer-body">
            <div className="container">
              <div className="row">
                <div className="col-xl-6 col-md-6 col-12 footer-col-block">
                  <div className="footer-heading footer-heading-desktop">
                    <h6>Information</h6>
                  </div>
                  <div className="footer-heading footer-heading-moblie">
                    <h6>Information</h6>
                  </div>
                  <ul className="footer-menu-list tf-collapse-content">
                    <li>
                      <a href="/about" className="footer-menu_item">
                        About Us
                      </a>
                    </li>
                    <li>
                      <a href="/contact" className="footer-menu_item">
                        Contact Us
                      </a>
                    </li>
                    <li>
                      <a href="/faqs" className="footer-menu_item">
                        FAQs
                      </a>
                    </li>
                  </ul>
                </div>
                <div className="col-xl-6 col-md-6 col-12 footer-col-block">
                  <div className="footer-heading footer-heading-desktop">
                    <h6>Help</h6>
                  </div>
                  <div className="footer-heading footer-heading-moblie">
                    <h6>Help</h6>
                  </div>
                  <ul className="footer-menu-list tf-collapse-content">
                    <li>
                      <a href="/privacy-policy" className="footer-menu_item">
                        Privacy Policy
                      </a>
                    </li>
                    <li>
                      <a href="/shipping-exchange" className="footer-menu_item">
                        Shipping & Exchange
                      </a>
                    </li>
                    <li>
                      <a href="/terms-conditions" className="footer-menu_item">
                        Terms & Conditions
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div className="footer-bottom">
            <div className="container">
              <div className="row">
                <div className="col-12">
                  <div className="footer-bottom-wrap d-flex gap-20 flex-wrap justify-content-between align-items-center">
                    <div className="footer-menu_item">
                      © {year}{" "}
                      {lang === "ar" ? settings.title_ar : settings.title}.{" "}
                      {getWord("All Rights Reserved")}
                    </div>
                    <div className="tf-payment">Powered By Weby</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>
      <div className="progress-wrap">
        <svg
          className="progress-circle svg-content"
          width="100%"
          height="100%"
          viewBox="-1 -1 102 102"
        >
          <path
            d="M50,1 a49,49 0 0,1 0,98 a49,49 0 0,1 0,-98"
            style={{
              transition: "stroke-dashoffset 10ms linear 0s",
              strokeDasharray: "307.919, 307.919",
              strokeDashoffset: "286.138",
            }}
          ></path>
        </svg>
      </div>
      <div className="tf-toolbar-bottom type-1150">
        <div className="toolbar-item">
          <a
            href="#toolbarShopmb"
            data-bs-toggle="offcanvas"
            aria-controls="offcanvasLeft"
          >
            <div className="toolbar-icon">
              <i className="icon-shop"></i>
            </div>
            <div className="toolbar-label">{getWord("Collections")}</div>
          </a>
        </div>
        <div className="toolbar-item">
          <a
            href="#canvasSearch"
            data-bs-toggle="offcanvas"
            aria-controls="offcanvasLeft"
          >
            <div className="toolbar-icon">
              <i className="icon-search"></i>
            </div>
            <div className="toolbar-label">{getWord("Search")}</div>
          </a>
        </div>
        <div className="toolbar-item">
          {user.isLoggedIn ? (
            <Link to="/user/dashboard" className="nav-icon-item">
              <div className="toolbar-icon">
                <i className="icon-account"></i>
              </div>
              <div className="toolbar-label">{getWord("Account")}</div>
            </Link>
          ) : (
            <>
              <a data-bs-toggle="modal" onClick={openLogin}>
                <div className="toolbar-icon">
                  <i className="icon-account"></i>
                </div>
                <div className="toolbar-label">{getWord("Account")}</div>
              </a>
              <Login isOpen={isLoginOpen} onClose={closeLogin}></Login>
            </>
          )}
        </div>
        <div className="toolbar-item">
          <a href="#shoppingCart" data-bs-toggle="modal">
            <div className="toolbar-icon">
              <i className="icon-bag"></i>
              <div className="toolbar-count">0</div>
            </div>
            <div className="toolbar-label">{getWord("Cart")}</div>
          </a>
        </div>
      </div>
      <div className="offcanvas offcanvas-start canvas-mb" id="mobileMenu">
        <span
          className="icon-close icon-close-popup"
          data-bs-dismiss="offcanvas"
          aria-label="Close"
        ></span>
        <div className="mb-canvas-content">
          <div className="mb-body">
            <ul className="nav-ul-mb" id="wrapper-menu-navigation"></ul>
          </div>
          <div className="mb-bottom">
            <div className="bottom-bar-language">
              <div className="tf-currencies">
                <select className="image-select center style-default type-currencies"></select>
              </div>
              <div className="tf-languages"></div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Footer;
